import { useState, createContext, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'

import moment from 'moment'
import { live, apiUrl, client, tableBigQuery, staging } from '../config/delcare'

let AppContext = createContext()

let AppContextProvider = ({ children }) => {

	const { logout } = useAuth0()
	const navigate = useNavigate()

	let {
		product_ids_total,
		product_edits_dev,
		product_edits,
		vw_products_dev,
		vw_products_live,
		marketplace_year_goals_dev,
		marketplace_year_goals_live
	} = tableBigQuery

	const [cols] = useState([
		"CAST(record_id as STRING) as record_id",
		"marketplace_id",
		"marketplace",
		"client_id",
		"child_asin",
		"client_title",
		"brand",
		"cogs",
		"client_name",
		"client_sku",
		"category",
		"subcategory",
		"attribute_1",
		"attribute_2"
	])

	const [selectedId, setSelectedId] = useState(null)
	const [currentPage, setCurrentPage] = useState(null)
	const [pages, setPages] = useState(0)
	const [pageLimit] = useState(100)
	const [count, setCount] = useState(0)
	const [authUser, setAuthUser] = useState({
		email: "",
		user_id: "",
		nickname: "",
		email_verified: "",
	})
	const [token, setToken] = useState(null)
	const [initUrl, setInitUrl] = useState("/")
	const [list, setList] = useState([])
	const [loginLoaded, setLoginLoaded] = useState(false)
	const [ids, setIds] = useState([])
	const [neonUser, setNeonUser] = useState({})
	const [marketplaceList, setMarketplaceList] = useState([])
	const [columns, setColumns] = useState([])
	const [displayColumns, setDisplayColumns] = useState([])
	const [clientlist, setClientList] = useState([])
	const [userInfo, setUserInfo] = useState({})
	const [agencyList, setAgencyList] = useState([])
	const [roles, setRoles] = useState([])
	const [mode, setMode] = useState(1)
	const [countries, setCountries] = useState([])
	const [hh, setHh] = useState(0)
	const [ww, setWw] = useState(0)
	const [offCanvas, setOffCanvas] = useState(null)
	const [popupSidebarType, setPopupSidebarType] = useState("")
	const [showCanvas, setShowCanvas] = useState(false)
	const [brandList, setBrandList] = useState([])
	const [sidebarTitle, setSideBarTitle] = useState("")
	const [brand, setBrand] = useState({})
	const [editBrandId, setEditBrandId] = useState("")
	const [toDeleteMarketplace, setToDeleteMarketplace] = useState(null)
	const [toDeleteProfile, setToDeleteProfile] = useState(null)
	const [toUnsubscribe, setToUnsubscribe] = useState(null)
	const [reloadAuthorizedMarketplaceList, setReloadAuthorizedMarketplaceList] = useState(false)
	const [reloadProfileList, setReloadProfileList] = useState(false)
	const [reloadSubscription, setReloadSubscription] = useState(false)
	const [path, setPath] = useState("")
	const [accessToken, setAccessToken] = useState('')
	const [dataFetchLoading, setDataFetchLoading] = useState(false)
	const [selectedUser, setSelectedUser] = useState(null)
	const sliderRef = useRef(null)
	const [reloadList, setReloadList] = useState(false)
	const [toastInit, setToastInit] = useState(null)
	const [toastContent, setToastContent] = useState("")
	const [queryAddon, setQueryAddon] = useState("")
	let [reloadProductTable, setReloadProductTable] = useState(false)
	const [selectedYearMarketplace, setSelectedYearMarketplace] = useState(null)
	let [reloadYearMarketplace, setReloadYearMarketplace] = useState(false)
	let [kioskEnable, setKioskEnable] = useState(null)
	let [clientAuthList, setClientAuthtList] = useState([])
	let [adsIssueList, setAdsIssueList] = useState([])
	let [dspList, setDspList] = useState([])
	let [allAdsProfileIds, setAllAdsProfileIds] = useState([])
	let [tooltips, setTooltips] = useState([])
	let [gettingUser, setGettingUser] = useState(false)

	let [adsProfileIdsLoaded, setAdsProfileIdsLoaded] = useState(false)

	function addslashes(string) {
		if (!string) return string
		return string
			.replace(/\\/g, '\\\\')
			.replace(/\u0008/g, '\\b')
			.replace(/\t/g, '\\t')
			.replace(/\n/g, '\\n')
			.replace(/\f/g, '\\f')
			.replace(/\r/g, '\\r')
			.replace(/'/g, '\\\'')
			.replace(/"/g, '\\"')
	}

	let qouteDelimiter = (string, type) => {
		if (!string) return string
		if (type == 1) return string.replace(/[']/g, "\'")
		if (type == 2) return string.replace(/[']/g, "")
		return string.replace(/[']/g, "''")
	}

	let [bigQueryTable] = useState({
		product_ids_total,
		product_edits: staging ? product_edits_dev : product_edits,
		vw_products: staging ? vw_products_dev : vw_products_live,
		marketplace_year_goals: staging ? marketplace_year_goals_dev : marketplace_year_goals_live,
	})

	const fetchDataV2 = async (queryName, params, endpoint) => {
		setDataFetchLoading(true)
		let headerData = new Headers()
		headerData.append("Content-Type", "application/json")
		headerData.append("live", live)
		if (token?.accessToken) headerData.append('Authorization', `Bearer ${token.accessToken}`)

		let data = null
		let url = `${apiUrl}${endpoint}`

		try {
			data = await fetch(url, {
				method: "POST",
				headers: headerData,
				body: JSON.stringify({ queryName, params })
			})
			await unauthorized(data)
		} catch (err) {
			return false
		} finally {
			setDataFetchLoading(false)
		}

		if (!data.ok) return false

		data = await data.json()
		return data
	}

	const fetchData = async (query, endpoint) => {
		setDataFetchLoading(true)
		let headerData = new Headers()
		headerData.append("Content-Type", "application/json")
		headerData.append("live", live)
		if (token?.accessToken) headerData.append('Authorization', `Bearer ${token.accessToken}`)

		let data = null
		try {
			data = await fetch(`${apiUrl}${endpoint}`, {
				method: "POST",
				headers: headerData,
				body: JSON.stringify({ query })
			})
			await unauthorized(data)
		} catch (err) {
			return false
		} finally {
			setDataFetchLoading(false)
		}

		if (!data.ok) return

		data = await data.json()
		return data
	}

	const getKeys = (x) => Object.keys(x)

	const getIds = async () => {
		let resp = await fetchDataV2("GET_IDS", [], "/neon-query-v2")
		setIds(resp.map(x => x.id))
		return resp.map(x => x.id)
	}

	const filterIds = async () => {
		let query = 'FILTER_IDS'
		let params = []

		if (["owner", "admin"].includes(neonUser.role)) {
			query = 'FILTER_IDS_OWNER'
			params = [neonUser.agency_id]
		}

		if (["normal", "editor"].includes(neonUser.role)) {
			query = "FILTER_IDS_NORMAL_EDITOR"
			params = [neonUser.agency_id]
		}

		let resp = await fetchDataV2(query, params, "/neon-query-v2")

		if (resp.length == 0 && ["normal", "editor"].includes(neonUser.role)) return []

		resp = resp.map(x => x.id)
		setIds(resp)
		return resp
	}

	const getNeonUser = async (id) => {
		// console.log("GETTING NEON USER")
		if (neonUser?.user_id) {
			// console.log("USER ALREADY HAS DATA")
			return false
		}

		let user_id = token?.idTokenPayload?.sub || id
		if (!user_id) {
			// console.log("USER ID INVALID", user_id)
			return
		}

		if (!!gettingUser) {
			// console.log("GETTING USER DATA ONGOING")
			return false
		}

		setGettingUser(true)

		let resp1 = await fetchDataV2("NEON_USER_1", [user_id], "/neon-query-v2")
		let resp3 = await fetchDataV2("NEON_USER_2", [user_id], "/neon-query-v2")
		// console.log({resp1, resp3})
		let resp2 = []
		if (resp1.length > 0 && !!resp1[0]?.agency_id) {
			resp2 = await fetchDataV2("NEON_USER_3", [resp1[0].agency_id], "/neon-query-v2")
		}

		let resp = {
			...resp1[0],
			...resp2[0],
			checklist: resp3[0],
			user: resp1[0]
		}
		resp.agency = resp2[0] ?? null

		setNeonUser(resp)
		setLoginLoaded(true)
		setGettingUser(false)

		return resp
	}

	const auth0VerifyEmail = async (user_id) => {
		try {
			let url = encodeURI(`${apiUrl}/set_email_verified?user_id=${user_id}`)
			let resp = await fetch(url, {
				method: "GET",
				headers: (() => {
					const myHeaders = new Headers()
					myHeaders.append("Content-Type", "application/json")
					myHeaders.append("Authorization", `Bearer ${token.accessToken}`)
					return myHeaders
				})()
			})
			await resp.json()
		} catch (err) {
			// silently fail
		}
	}

	const getMarketPlace = async () => {
		if (!neonUser.user_id) return

		let resp = await fetchDataV2("GET_MARKETPLACE", [], "/neon-market-v2")

		const regionCode = [
			{ region: "north america", code: "NA" },
			{ region: "europe", code: "EU" },
			{ region: "fareast", code: "FA" },
		]

		if (!Array.isArray(resp) || resp === false) return

		resp = resp.map(x => ({
			...x,
			regionCode: regionCode.find(xx => xx.region == x.region)
		}))

		setMarketplaceList(resp)
		return resp
	}

	const getRoleView = () => ["admin", "owner", "editor"].includes(neonUser.role)

	const getList = async (id) => {
		let query = "GET_LIST_OWNER_ADMIN", params = [neonUser.agency_id, Number(id)]

		if (["normal", "editor"].includes(neonUser.role)) {
			query = "GET_LIST_NORMAL_EDITOR"
			params = [Number(id)]
		}

		let resp = await fetchDataV2(query, params, "/neon-query-v2")

		setSelectedId(id)
		setList(resp)
		return resp
	}

	const getColumns = async () => {
		let sql = "SELECT column_name,data_type FROM `bispoke-sidekick.product_info.INFORMATION_SCHEMA.COLUMNS` WhERE table_name = 'product_adds_edits_deletes'"
		let resp = await fetchData(sql, "/bigquery-sql")

		setColumns(resp)

		let final = resp
			.filter(x => !["record_id", "IS_ADD_EDIT_DELETE", "BY_USER", "marketplace"].includes(x.column_name))
			.map(x => ({ ...x, value: "" }))

		setDisplayColumns(final)
	}

	const getDataType = (type) => {
		if (["INT64", "FLOAT64"].includes(type)) return "number"
		if (type == "STRING") return "text"
	}

	const getClientList = async () => {
		let resp = await fetchDataV2("GET_CLIENT_LIST", [neonUser.agency_id], "/neon-query-v2")
		setClientList(resp)
		return resp
	}

	const getUserInfo = async (id) => {
		let resp = await fetchDataV2("GET_USER_INFO", [id], "/neon-query-v2")
		setUserInfo(resp[0])
		return resp
	}

	const getRoles = async () => {
		let resp = await fetchDataV2("GET_ROLES", [], "/neon-query-v2")
		resp = resp.map(x => x.unnest)
		setRoles(resp.filter(x => !['admin', 'owner'].includes(x)))
		return resp
	}

	const createProducModifyLog = async (IS_ADD_EDIT_DELETE, marketPlace) => {
		let colArr = displayColumns.map(x => x.column_name)

		if (IS_ADD_EDIT_DELETE == 'DELETE') {
			await fetchDataV2("LOG_PRODUCT_DELETE", {
				record_id: marketPlace.record_id,
				user_id: token.idTokenPayload.sub,
				timestamp: moment().format('YYYY-MM-DD HH:mm:ss')
			}, "/bigquery-sql-v2")
		} else {
			await fetchDataV2("LOG_PRODUCT_MODIFY", {
				record_id: Math.floor((Math.random()) * (999999999999 - 100000000000 + 1)) + 100000000000,
				marketplace_id: marketPlace.id,
				client_id: displayColumns[colArr.indexOf('client_id')].value,
				child_asin: displayColumns[colArr.indexOf('child_asin')].value,
				client_title: displayColumns[colArr.indexOf('client_title')].value,
				brand: displayColumns[colArr.indexOf('brand')].value,
				cogs: displayColumns[colArr.indexOf('cogs')].value || null,
				client_name: displayColumns[colArr.indexOf('client_name')].value,
				client_sku: displayColumns[colArr.indexOf('client_sku')].value,
				category: displayColumns[colArr.indexOf('category')].value,
				subcategory: displayColumns[colArr.indexOf('subcategory')].value,
				attribute_1: displayColumns[colArr.indexOf('attribute_1')].value,
				attribute_2: displayColumns[colArr.indexOf('attribute_2')].value,
				marketplace: marketPlace.country,
				action: IS_ADD_EDIT_DELETE,
				user_id: token.idTokenPayload.sub,
				timestamp: moment().format('YYYY-MM-DD HH:mm:ss')
			}, "/bigquery-sql-v2")
		}
	}

	const getAllCountries = async () => {
		let resp = null
		try {
			resp = await fetch('/src/country.json')
			resp = await resp.json()
			let top = resp.filter(x => ["US", "CA", "MX"].includes(x.cca2))
			top = top.sort((a, b) => b.name.common.localeCompare(a.name.common))
			resp = resp
				.sort((a, b) => a.name.common.localeCompare(b.name.common))
				.filter(x => !["US", "CA", "MX"].includes(x.cca2))
			resp = [...top, ...resp]
		} catch (err) {
			resp = [{
				name: {
					common: "United States",
					official: "United States of America",
					nativeName: { eng: { official: "United States of America", common: "United States" } }
				},
				cca2: "US"
			}]
		} finally {
			setCountries(resp)
		}
		return resp
	}

	const getSrollHeight = (h) => setHh(h)

	const getBrands = async () => {
		if (marketplaceList.length == 0 || !neonUser?.user_id || !neonUser?.agency?.agency_id) {
			// console.log("MARKETPLACE REQUIRED TO GET BRANDS")
			return false
		}
		if (!adsProfileIdsLoaded) {
			// console.log("PROFILE LIST REQUIRED TO GET BRANDS")
			return false
		}

		let brands = await fetchDataV2("GET_BRANDS_1", [neonUser.agency.agency_id], "/neon-query-v2")
		let profile_info = await fetchDataV2("GET_BRANDS_2", [neonUser.agency.agency_id], "/neon-query-v2")
		let marketplace_list = await fetchDataV2("GET_BRANDS_3", [neonUser.agency.agency_id], "/neon-query-v2")
		let ads_list = await fetchDataV2("GET_BRANDS_4", [neonUser.agency.agency_id], "/neon-query-v2")

		marketplace_list = marketplace_list.map(x => {
			let info = marketplaceList.find(xx => xx.id == x.marketplace_id) ?? null
			return { ...x, marketplace_info: info }
		})

		let list_compare = profile_info
			.filter(x => !['seller_central', 'vendor_central', null].includes(x.profile_type))
			.map(x => x.profileId)
			.filter(x => !!x)
		let missing = list_compare.filter(x => !allAdsProfileIds.includes(x)).filter(x => x != '0')
		// console.log("MISSING", missing)


		brands = brands.map(x => {
			let ads = profile_info
				.filter(xx => ads_list
					.filter(xxx => Number(xxx.brand_id) == x.id)
					.map(xxx => Number(xxx.client_profile_id))
					.includes(Number(xx.profile_id)))
				.map(xx => xx.profile_type == 'dsp' ? xx.advertiser_id : xx.profileId)

			return {
				...x,
				marketplace_list: marketplace_list.filter(xx => xx.brand_entity_id == x.brand_entity_id),
				profile_list: profile_info.filter(xx => Number(xx.client_entity_id) == x.brand_entity_id),
				ads_list: ads,
				has_error: (() => {
					let list = profile_info
						.filter(xx => xx.client_entity_id == x.brand_entity_id)
						.map(xx => Number(xx.client_id))
					let err = clientAuthList.filter(xx => !xx.status).map(xx => xx.client_info_id)
					// let hasAuthError = list.some(xx => err.includes(xx))
					let hasMissingAds = missing.filter(xx => ads.includes(xx)).length > 0

					// console.log({brand: x.brand, err: clientAuthList.filter(xx => !xx.status), hasAuthError, hasMissingAds, list})
					// return hasAuthError || hasMissingAds
					return hasMissingAds
				})()
			}
		})

		brands = brands.map(x => ({
			...x,
			profile_list: x.profile_list.filter(xx =>
				x.marketplace_list.map(xxx => xxx.marketplace_info.countrycode).includes(xx.countryCode)
				&& ['seller_central', 'vendor_central'].includes(xx.profile_type)
			)
		}))
		// console.log("BRANDS", brands.filter(x => x['active?']))
		setBrandList(brands)
		return brands
	}

	const toggleCanvas = () => {
		if (showCanvas) return offCanvas.show()
		offCanvas.hide()
	}

	const updateChecklist = async (column, user_id, setFalse) => {
		if (["editor", "normal"].includes(neonUser.role)) return false
		if (!column) return false
		if (neonUser.checklist && column in neonUser.checklist && !setFalse) return false

		const QUERY_MAP = {
			"seller_account": "UPDATE_CHECKLIST_SELLER_ACCOUNT",
			"market_plan": "UPDATE_CHECKLIST_MARKET_PLAN",
			"subscribe": "UPDATE_CHECKLIST_SUBSCRIBE",
			"download": "UPDATE_CHECKLIST_DOWNLOAD",
			"data_backfill": "UPDATE_CHECKLIST_DATA_BACKFILL",
		}

		const queryName = QUERY_MAP[column]
		if (!queryName) return false

		return await fetchDataV2(queryName, [setFalse ? false : true, user_id], "/neon-query-v2")
	}

	const unauthorized = async (data) => {
		if (data.status >= 400 && data.status < 500) {
			logout({
				clientId: client,
				logoutParams: { returnTo: window.location.origin }
			})
			window.localStorage.clear()
		}
	}

	const validateEmail = (email) => {
		return String(email).toLowerCase().match(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		)
	}

	function isNumber(n) {
		n = parseFloat(n).toFixed(2)
		return Number(n).toLocaleString('en')
	}

	const userOwnsBrand = (currentUser, selectedBrand) => {
		if (!selectedBrand.agency_id) return
		if (currentUser.agency_id != selectedBrand.agency_id) {
			navigate("/brand", { replace: true })
		}
	}

	const getAgencyClients = async () => {
		if (!neonUser?.user_id) return
		if (clientAuthList.length > 0) return

		let resp = []
		try {
			resp = await fetchDataV2("GET_AGENCY_CLIENTS_1", [neonUser.agency_id], "/neon-market-v2")
			let resp2 = await fetchDataV2("GET_AGENCY_CLIENTS_2", [neonUser.agency_id], "/neon-query-v2")
			let resp3 = await fetchDataV2("GET_AGENCY_CLIENTS_3", [neonUser.agency_id], "/neon-query-v2")
			// console.log(resp)	
			if (resp == false || resp.length == 0) {
				resp = []
				resp2 = []
			}

			resp = resp
				.map(x => {
					let data = resp2.filter(xx => Number(xx.client_id) == x.client_info_id)
					return { ...x, profile_info: data.length > 0 ? data[0] : null }
				}).map(x => {
					if (!x.profile_info) return { ...x, brand: null }
					let data2 = resp3.filter(xx => Number(x.profile_info.client_entity_id) == xx.brand_entity_id)
					return { ...x, brand: data2.length > 0 ? data2[0] : null }
				})
		} catch (err) {
			resp = []
		} finally {
			// console.log("AUTH CLIENT LIST", resp.filter( x => x?.brand?.['active?'] && !x.status) )
			// console.log(resp)
			setClientAuthtList(resp)
			return resp
		}
	}

	const getAdsAuthStatus = async (sellerVendorTable, page) => {
		let profile_id_list = sellerVendorTable.map(x =>
			x.profile_type == 'dsp' ? x.profile.advertiser_id : x.profile.profileId
		)
		let dsp_list = page == 'brand_auth'
			? sellerVendorTable.map(x => x.profile.client_id)
			: sellerVendorTable.map(x => x.client_id)

		let resp = await fetchDataV2("GET_ACTIVE_ADS_ACCOUNTS_1", [profile_id_list], "/neon-market-v2")

		if (dsp_list.length > 0) {
			try {
				let resp2 = await fetchDataV2("GET_ACTIVE_ADS_ACCOUNTS_2", [dsp_list], "/neon-market-v2")
				setDspList(resp2.map(x => x.dspadvertiserid))
			} catch (err) {
				// silently fail
			}
		}

		if (!Array.isArray(resp) || resp === false) return false

		let dataList = resp.map(x => `${x.profileid}_${x.client_id}`)
		let tableList = sellerVendorTable.map(x =>
			`${x.profile.profileId || x.profile.advertiser_id}_${x.profile.client_id}`
		)

		let value = tableList.filter(x => !dataList.includes(x))
		if (value.length > 0) {
			setAdsIssueList(value)
			return value
		}

		return []
	}

	const getAllAdsProfileIds = async (agency_id) => {
		let resp = []
		try {
			resp = await fetchDataV2("GET_ALL_ADS_PROFILE_IDS", [agency_id], "/neon-market-v2")
			resp = resp.map(x => x.profileid)
			// console.log("GET ALL ADS PROFILE IDS", resp)
			setAllAdsProfileIds(resp)

		} catch (err) {

			// silently fail
		} finally {
			setAdsProfileIdsLoaded(true)
			return resp.map(x => x.profileid)
		}
	}

	const hideAllTooltip = () => {
		tooltips.forEach(tooltip => {
			try { tooltip.hide() } catch (e) { /* silently fail */ }
		})
	}

	const disposeAllTooltip = () => {
		tooltips.forEach(x => {
			try { x.dispose() } catch (e) { /* silently fail */ }
		})
		setTooltips([])
	}

	const testMoment = () => moment().format("YYYY-MM-DD HH:mm:ss")

	return (
		<AppContext.Provider value={{
			addslashes,
			qouteDelimiter,
			cols,
			selectedId, setSelectedId,
			fetchData,
			getKeys,
			currentPage, setCurrentPage,
			pages, setPages,
			pageLimit,
			count, setCount,
			authUser, setAuthUser,
			token, setToken,
			initUrl, setInitUrl,
			list, setList,
			loginLoaded, setLoginLoaded,
			getIds,
			ids, setIds,
			neonUser, setNeonUser,
			getNeonUser,
			auth0VerifyEmail,
			marketplaceList, setMarketplaceList,
			getMarketPlace,
			filterIds,
			getList,
			getRoleView,
			getColumns,
			columns, setColumns,
			displayColumns, setDisplayColumns,
			getDataType,
			getClientList,
			clientlist, setClientList,
			getUserInfo,
			userInfo, setUserInfo,
			agencyList, setAgencyList,
			getRoles,
			roles, setRoles,
			createProducModifyLog,
			mode, setMode,
			getAllCountries,
			countries, setCountries,
			hh, setHh,
			getSrollHeight,
			offCanvas, setOffCanvas,
			popupSidebarType, setPopupSidebarType,
			showCanvas, setShowCanvas,
			getBrands,
			brand, setBrand,
			brandList, setBrandList,
			sidebarTitle, setSideBarTitle,
			editBrandId, setEditBrandId,
			toggleCanvas,
			toDeleteMarketplace, setToDeleteMarketplace,
			reloadAuthorizedMarketplaceList, setReloadAuthorizedMarketplaceList,
			toDeleteProfile, setToDeleteProfile,
			reloadProfileList, setReloadProfileList,
			toUnsubscribe, setToUnsubscribe,
			reloadSubscription, setReloadSubscription,
			ww, setWw,
			path, setPath,
			accessToken, setAccessToken,
			dataFetchLoading, setDataFetchLoading,
			updateChecklist,
			unauthorized,
			validateEmail,
			selectedUser, setSelectedUser,
			sliderRef,
			reloadList, setReloadList,
			toastInit, setToastInit,
			toastContent, setToastContent,
			bigQueryTable,
			isNumber,
			queryAddon, setQueryAddon,
			reloadProductTable, setReloadProductTable,
			selectedYearMarketplace, setSelectedYearMarketplace,
			reloadYearMarketplace, setReloadYearMarketplace,
			kioskEnable, setKioskEnable,
			userOwnsBrand,
			clientAuthList, setClientAuthtList,
			getAgencyClients,
			adsIssueList, setAdsIssueList,
			getAdsAuthStatus,
			dspList, setDspList,
			getAllAdsProfileIds,
			allAdsProfileIds, setAllAdsProfileIds,
			tooltips, setTooltips,
			disposeAllTooltip,
			hideAllTooltip,
			fetchDataV2,
			testMoment,
			adsProfileIdsLoaded
		}}>
			{children}
		</AppContext.Provider>
	)
}

export { AppContext, AppContextProvider }